export function get(obj: any, path: string, def?: any) {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj) ?? def;
}

export function getSubArray(obj: any, path: string, fallback?: any) {
    if(path.includes('.')){
        return path
        .split('.')
        .reduce((o, key) => (o && o[key] !== undefined ? o[key] : fallback), obj);
    }else{
        return obj[path]
    }
    
}